import Pageone from "./Page1/Pageone";
import Pagetwo from "./Page2/Pagetwo";
import Pagethree from "./Page3/Pagethree";
import Footer from "./Footer/Footer";
import Pagefour from "./Page4/Pagefour";

function Body() {
  return (
    <div>
      <Pageone />
      <Pagetwo />
      <Pagethree />
      <Pagefour />
      <Footer />
    </div>
  );
}

export default Body;
